import { Component } from '@angular/core';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HomePageComponent } from '../../../../features/home-page/home-page.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    ToolbarComponent,
    HomePageComponent,
    FooterComponent,
    MatProgressSpinnerModule,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  showLoading = false;
  onLoadingEvent(event: boolean) {
    this.showLoading = event;
  }
}
